import Proptypes from 'prop-types'
import { StyledTitle } from './styles'

export const Title = ({ text, langPart }) => {
  const formattedText = text.replace(/[^\S\r\n]+/g, ' ');
  return <StyledTitle dangerouslySetInnerHTML={{ __html: formattedText }} $langPart={langPart} />
}

Title.propTypes = {
  text: Proptypes.any,
  langPart: Proptypes.bool,
}

export default Title
